export default "__VITE_ASSET__bY6g6RhX__"